module.exports = __webpack_public_path__ + "img/24.0d4b1826.png";